import React, { useEffect, useState } from 'react'
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Button, TextField, CircularProgress } from '@material-ui/core';
import DataTable from '../Table';
import { useDispatch, useSelector } from 'react-redux';
import { getAllPM_logs } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import { ToastContainer, toast } from 'react-toastify';
import GetAppIcon from '@material-ui/icons/GetApp';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { convertUTCtoIST } from '../../helpers/DateConvert'
import * as XLSX from 'xlsx';
import { getAssetwithVendorCode, getVendorData } from '../../ReduxStore/VendorDataSlice';
import { getMasterTableData } from '../../ReduxStore/MastertableSlice';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { formatDateTime, customStyles } from '../../helpers/DateConvert';


// Create a styled version of the Button component
// const CustomButton = withStyles({
//     root: {
//         fontSize: '14px',
//         textTransform: 'Capitalize',
//     },
// })(Button);

// const customStyles = {
//     menu: (provided) => ({
//         ...provided,
//         zIndex: 9999,
//     }),
//     control: (provided) => ({
//         ...provided,
//         minHeight: '54px',
//         height: '54px',
//     }),
//     valueContainer: (provided) => ({
//         ...provided,
//         height: '54px',
//         padding: '0 8px',
//     }),
// };

const columns = [
    { id: 'Sr.no', label: 'Sr.no', minWidth: 50 },
    { id: 'machine_details.asset_no', label: 'Asset', minWidth: 80 },
    { id: 'machine_details.asset_text', label: 'Description', minWidth: 150 },
    { id: 'machine_details.material_no', label: 'Part No', minWidth: 100 },
    { id: 'frequency', label: 'Frequency', minWidth: 80 },
    { id: 'current_plan_date', label: 'Current Plan Date', minWidth: 120 },
    { id: 'next_plan_date', label: 'Next Plan Date', minWidth: 120 },
    { id: 'due_date', label: 'Due Date', minWidth: 120 },
    { id: 'status', label: 'Status', minWidth: 80 },
    { id: 'last_activity_time', label: 'Last Activity Time', minWidth: 150 },
    { id: 'total_checkpoints', label: 'Total Checkpoints', minWidth: 120 },
    { id: 'checkpoints_submitted', label: 'Checkpoints Submitted', minWidth: 150 },
    { id: 'checkpoints_approved', label: 'Checkpoints Approved', minWidth: 150 },
    { id: 'checkpoints_rejected', label: 'Checkpoints Rejected', minWidth: 150 },
    { id: 'NG_checkpoints', label: 'NG Checkpoints', minWidth: 150 },
    { id: 'duration', label: 'Duration (Hrs)', minWidth: 100 },
    { id: 'done_by', label: 'Done By', minWidth: 100 },
    { id: 'log_user_name', label: 'Log User', minWidth: 150 },
    { id: 'machine_details.storage_location', label: 'Vendor Code', minWidth: 120 },
    { id: 'machine_details.vendor_name', label: 'Vendor Name', minWidth: 120 }
];

const Logoverview = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: ' Preventive Maintenance', href: '/preventive-maintenance' }
    ];
    const [loading, setLoading] = useState(true);
    const [searchLoading, setSearchLoading] = useState(false);
    const [resestLoading, setResetLoading] = useState(false);
    const [PmLogs, setPmLogs] = useState([]);
    const Role = localStorage.getItem("userRole");
    const [masterData, setMasterData] = useState([]);
    const { response } = useSelector(state => state.vendor);

    const [AssetOptions, setAssetOptions] = useState([]);
    const [SupplierOptions, setSupplierOptions] = useState(null);
    const [selectedSupplier, setselectedSupplier] = useState(null);
    const [selectedAsset, setselectedAsset] = useState(null);
    const [formData, setFormData] = useState({
        startDate: '',
        endDate: ''
    });
    const [filteredLogs, setFilteredLogs] = useState(PmLogs);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const formatDuration = (seconds) => {
        const hours = Math.floor(seconds / 3600);  // Get the number of hours
        const minutes = Math.floor((seconds % 3600) / 60);  // Get the remaining minutes
        // return `${hours} hr ${minutes} min`;
        return `${hours} hr`;
    };

    const searchHandler = async () => {
        if (!formData.startDate) {
            toast.warn("Please select the Start Date first!")
            return
        }
        setSearchLoading(true)
        await getPmlogs(`?log_start=0&log_limit=20&from_time=${formatDateTime(formData.startDate)}&to_time=${formatDateTime(formData.endDate)}&paginate=true`)
        setSearchLoading(false)

    }

    const resetHandler = async () => {
        setResetLoading(true)
        setFormData({ startDate: '', endDate: '' });
        await getPmlogs(); // Refresh logs without filters
        setResetLoading(false)
    };


    const getPmlogs = async (param) => {
        try {
            const action = dispatch(getAllPM_logs(param));
            const res = await action.unwrap();
            if (res.result) {
                // Process the data to remove the first 3 letters from asset_no if it exists
                const modifiedData = res.result.PM_log_table.map(item => ({
                    ...item,
                    machine_details: {
                        ...item.machine_details,
                        asset_no: item.machine_details?.asset_no ? item.machine_details.asset_no.slice(3) : item.machine_details.asset_no
                    }
                }));

                const mergedLogs = modifiedData.map(log => {
                    const comment = log.approval_comment ? Object.values(log.approval_comment) : [];
                    return {
                        ...log,
                        next_plan_date: convertUTCtoIST(log.next_plan_date),
                        current_plan_date: convertUTCtoIST(log.current_plan_date),
                        due_date: convertUTCtoIST(log.due_date),
                        approval_time: log?.approval_comment ? convertUTCtoIST(log.approval_time) : log.approval_comment,
                        duration: log?.duration ? formatDuration(log.duration) : log.duration,
                        last_activity_time: convertUTCtoIST(log.last_activity_time),
                        approval_comment: comment
                    }

                });
                setPmLogs(mergedLogs)
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }


    const assetDataforVendor = async () => {
        try {
            // setLoading(true)
            const action = dispatch(getAssetwithVendorCode());
            const res = await action.unwrap();
            if (res.result) {
                setLoading(false)
                setMasterData(res.result)
            };
        } catch (error) {
            toast.error(error.message || "Asset Not Found!");
        } finally {
            // setLoading(false)
        }
    }

    const getAssetDataforVendor = async (vendor_code) => {
        try {
            // setLoading(true)
            const action = dispatch(getMasterTableData({ page: 1, limit: 500, queryParams: `vendor_code=${vendor_code}` }));
            const res = await action.unwrap();
            console.log("ALL DATA", res.result.data)
            if (res.result.data) {
                setLoading(false)
                if (res.result.data.length > 0) {
                    setMasterData(res.result.data)
                } else {
                    toast.info("Asset Not Found!")
                }
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Asset Not Found!");
        } finally {
            // setLoading(false)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await getPmlogs('?log_start=0&log_limit=20');
            setLoading(false);
        };
        fetchData();
        if (Role === "admin") {
            dispatch(getVendorData());
        } else {
            // dispatch(getAssetwithVendorCode());
            assetDataforVendor();
        }
    }, [Role])

    useEffect(() => {
        const Supplierlist = response && response.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`,
            value: item.vendor
        }));

        if (Supplierlist) {
            setSupplierOptions(Supplierlist.map((item, index) => ({
                value: item.value,
                label: item.label
            })));
        }

        const Assetlist = masterData && masterData.map(item => ({
            value: item.asset_no || item.Asset_no,
            // label: item.Asset_description || item['Asset description'],
            label: `${(item.asset_no)?.slice(3) || (item.Asset_no?.slice(3))} - ${item['Asset description'] || item.Asset_description}`,
            // label: `${item.asset_no} - ${item['Asset description'] || item.Asset_description}`,
        }));

        if (Assetlist) {
            setAssetOptions(Assetlist.map(item => ({
                value: item.value,
                label: item.label,
            })));
        }
    }, [masterData, response]);

    useEffect(() => {
        if (selectedSupplier) {
            getAssetDataforVendor(selectedSupplier.value);
        }

    }, [selectedSupplier])

    // Filter logs based on selected supplier
    useEffect(() => {
        if (selectedSupplier) {
            const vendorName = selectedSupplier.label.split('(')[0].trim();
            console.log("Vendor Name for filtering:", vendorName);

            const filtered = PmLogs.filter(
                (log) => log.machine_details.vendor_name === vendorName
            );
            setFilteredLogs(filtered);
        } else {
            setFilteredLogs(PmLogs);
        }

    }, [selectedSupplier, PmLogs]);

    // Filter logs based on selected asset
    useEffect(() => {
        if (selectedAsset) {
            const assetNo = selectedAsset.value.replace(/^PVP/, '').trim(); // Remove 'PVP' prefix
            // console.log("Normalized Asset Number for filtering:", assetNo);
            // PmLogs.forEach((log, index) => {
            //     console.log(
            //         `Log ${index}:`,
            //         log.machine_details.asset_no,
            //         typeof log.machine_details.asset_no
            //     );
            // });

            const filtered = PmLogs.filter(
                (log) => log.machine_details.asset_no === assetNo
            );
            setFilteredLogs(filtered);
        } else {
            setFilteredLogs(PmLogs);
        }

    }, [selectedAsset, PmLogs]);

    const exportToExcel = () => {
        // Create a new worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(PmLogs);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Generate a buffer and trigger the download
        XLSX.writeFile(workbook, 'PM_Logs.xlsx');
    };

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Log Overview" />
                </Box>
                {/* <Box mb={2}>
                    <Grid container spacing={1} className='log-row'>
                        {Role === "admin" && <Grid item xs={12} sm={2}>
                            <Select
                                styles={customStyles}
                                options={SupplierOptions}
                                placeholder="Select Vendor"
                                isSearchable
                                onChange={setselectedSupplier}
                                isClearable
                                menuPlacement="auto"
                            />
                        </Grid>}
                        <Grid item xs={12} sm={Role === "admin" ? 2 : 3}>
                            <Select
                                styles={customStyles}
                                options={AssetOptions}
                                placeholder="Select Asset"
                                isSearchable
                                isClearable
                                onChange={setselectedAsset}
                                menuPlacement="auto"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="From"
                                name="startDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="To"
                                name="endDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.endDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <CustomButton
                                type="submit"
                                variant="contained"
                                color="primary"
                                className="customButton"
                                fullWidth
                                onClick={searchHandler}
                            >
                                Search
                            </CustomButton>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <CustomButton
                                type="submit"
                                variant="contained"
                                color="primary"
                                className="customButton"
                                fullWidth
                                onClick={exportToExcel}
                            >
                                Export to Excel
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Box> */}
                <Box mt={3} mb={2}>
                    <Grid container spacing={1}>
                        {Role === "admin" && <Grid item xs={12} sm={2}>
                            <Select
                                styles={customStyles}
                                options={SupplierOptions}
                                placeholder="Select Vendor"
                                isSearchable
                                onChange={setselectedSupplier}
                                isClearable
                                menuPlacement="auto"
                            />
                        </Grid>}
                        <Grid item xs={12} sm={Role === "admin" ? 2 : 3}>
                            <Select
                                styles={customStyles}
                                options={AssetOptions}
                                placeholder="Select Asset"
                                isSearchable
                                isClearable
                                onChange={setselectedAsset}
                                menuPlacement="auto"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="From"
                                name="startDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                size='small'
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="To"
                                name="endDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                size='small'
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.endDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="primary"
                                className="customButton"
                                fullWidth
                                onClick={searchHandler}
                                // endIcon={searchLoading ? <CircularProgress size={20} /> : <SearchIcon />}
                                endIcon={
                                    searchLoading ? (
                                        <CircularProgress
                                            size={24} // Match the SearchIcon size
                                            style={{ color: 'white' }} // Make CircularProgress white
                                        />
                                    ) : (
                                        <SearchIcon fontSize="medium" /> // Adjust size as needed
                                    )
                                }
                            // endIcon={<SearchIcon />}
                            >
                                Search
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="customButton"
                                fullWidth
                                onClick={resetHandler}
                                // endIcon={<RefreshIcon />}
                                endIcon={
                                    resestLoading ? (
                                        <CircularProgress
                                            size={16} // Match the SearchIcon size
                                            style={{ color: 'white' }} // Make CircularProgress white
                                        />
                                    ) : (
                                        <RefreshIcon fontSize="medium" /> // Adjust size as needed
                                    )
                                }
                            >
                                Reset
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                className="customButton"
                                fullWidth
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export to Excel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                {filteredLogs.length > 0 ? (<Box mb={2}>
                    <Grid container>
                        <Grid item xs={12}>
                            <DataTable data={filteredLogs} columns={columns} pagination={false} />
                        </Grid>
                    </Grid>
                </Box>) : (
                    <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                        <Typography variant="h5">No PM Logs</Typography>
                    </Box>
                )}
            </Container>
            <ToastContainer />
        </Layout>
    )
}

export default Logoverview